module.exports = __webpack_public_path__ + "img/raw-material.971bc2a5.svg";